export default __webpack_public_path__ + "static/media/gasag_background_l2.59d16527.jpg";